export default "__VITE_ASSET__DjJf3w42__"